import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabsserviceinsanaswadi() {



  const cardData =
  {
    keyword: 'Corporate Cabs Services in Sanaswadi',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cabs Services in Sanaswadi',
    headingDescription: 'Pune Corporate Cars India Private Limited offers efficient and professional Corporate Cabs Services in Sanaswadi, providing smooth and reliable transportation solutions for industrial units, factories, warehouses, and corporate offices in this growing industrial hub. Our fleet of well-maintained sedans, SUVs, and employee-transport vehicles ensures comfortable and punctual commuting for staff, managers, executives, and visiting clients. With experienced chauffeurs, GPS-enabled vehicles, and flexible rental plans, we guarantee safe and hassle-free mobility every day. Whether your organization requires shift-based employee transport, dedicated corporate cars, client pickups, or outstation business travel, Pune Corporate Cars India Private Limited delivers top-quality and dependable cab services tailored to Sanaswadi’s industrial and corporate requirements.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Sanaswadi MIDC Transport",
    "description": "Sanaswadi MIDC Transport provides reliable and well-structured travel solutions for employees working in factories, warehouses, production units, and manufacturing plants across Sanaswadi MIDC. With AC sedans, shuttle vans, and tempo travellers, this service ensures smooth, punctual, and safe commute for workers and staff. Designed for multi-shift operations, Sanaswadi MIDC Transport guarantees timely pickups, verified drivers, and optimized routes to support uninterrupted industrial activities."
  },
  {
    "name": "Industrial Employee Cab Sanaswadi",
    "description": "Industrial Employee Cab Sanaswadi is specifically designed for employees working in industrial units and manufacturing facilities. The service offers AC/non-AC cabs, trained chauffeurs, and flexible pickup points to match factory timings. With GPS monitoring, safe driving practices, and timely arrivals, Industrial Employee Cab Sanaswadi ensures dependable day and night commute for all industrial employees."
  },
  {
    "name": "Factory Staff Shuttle Sanaswadi",
    "description": "Factory Staff Shuttle Sanaswadi provides high-capacity shuttle vans and minibuses to transport factory workers efficiently across multiple locations. Ideal for industries with large workforce requirements, this service supports fixed-route shuttle operations, peak-hour travel management, and night-shift commuting. Factory Staff Shuttle Sanaswadi ensures economical, coordinated, and time-bound group transportation."
  },
  {
    "name": "Company Cab Provider Sanaswadi",
    "description": "Company Cab Provider Sanaswadi offers fully managed transportation solutions for businesses operating in Sanaswadi MIDC. From executive travel to daily employee commuting, the service includes clean AC vehicles, professional drivers, and real-time monitoring. Company Cab Provider Sanaswadi is ideal for manufacturing units, warehouses, logistics firms, and corporate offices in the region."
  },
  {
    "name": "Sanaswadi Staff Pickup Drop",
    "description": "Sanaswadi Staff Pickup Drop ensures smooth, punctual, and safe daily travel for staff working in factories, industrial areas, and corporate units. Multi-shift operations, flexible pickup points, and verified drivers make it a convenient option for all employee categories. Sanaswadi Staff Pickup Drop reduces delays and improves commute reliability for the workforce."
  },
  {
    "name": "Sanaswadi Business Cab Hire",
    "description": "Sanaswadi Business Cab Hire provides executive travel solutions for managers, supervisors, and visitors traveling within or outside Sanaswadi MIDC. With AC sedans, SUVs, and chauffeur-driven cars, the service ensures professionalism, comfort, and punctuality. Sanaswadi Business Cab Hire is ideal for plant visits, corporate meetings, and outstation business travel."
  },
  {
    "name": "Monthly Corporate Cab Sanaswadi",
    "description": "Monthly Corporate Cab Sanaswadi offers long-term cab rental solutions with dedicated vehicles and drivers assigned to the company. Perfect for daily employee commute, supervisor visits, and inter-branch travel, this service ensures predictable pricing, continuous availability, and professional fleet management. Monthly Corporate Cab Sanaswadi supports companies in optimizing travel costs."

  },
  {
    "name": "Best Corporate Cabs Sanaswadi",
    "description": "Best Corporate Cabs Sanaswadi delivers premium, safe, and punctual corporate cab services for businesses operating in Sanaswadi MIDC. With a wide fleet of sedans, SUVs, vans, and shuttles, the service ensures comfortable commuting for employees and executives. Best Corporate Cabs Sanaswadi is trusted by industries for its reliability, clean vehicles, and trained drivers."
  },
  {
    "name": "Affordable Cab Service Sanaswadi",
    "description": "Affordable Cab Service Sanaswadi provides cost-effective employee transportation options without compromising safety or comfort. Ideal for small and medium industrial units, the service includes shared cabs, fixed routes, and budget-friendly monthly plans. Affordable Cab Service Sanaswadi ensures dependable travel while helping companies reduce commuting expenses."
  },
  {
    "name": "Employee Commute Sanaswadi",
    "description": "Employee Commute Sanaswadi offers seamless daily commuting solutions for factory workers, office staff, and technicians. With on-time pickup and drop services, GPS-enabled vehicles, and trained drivers, it ensures efficient and safe employee movement. Employee Commute Sanaswadi supports companies in improving workforce productivity and attendance."
  },
  {
    "name": "Corporate Fleet Sanaswadi",
    "description": "Corporate Fleet Sanaswadi provides businesses with a fully managed fleet of sedans, SUVs, shuttles, and vans for different transportation needs. The service covers employee commute, executive travel, inter-factory movement, and logistics support. Corporate Fleet Sanaswadi ensures reliability, safety, and scalability for growing organizations."
  },
  {
    "name": "Outstation Cab Sanaswadi",
    "description": "Outstation Cab Sanaswadi offers safe, comfortable, and timely long-distance travel for business trips, factory visits, intercity meetings, and corporate tours. With AC sedans and SUVs driven by experienced chauffeurs, the service ensures a smooth outstation journey across Maharashtra. Outstation Cab Sanaswadi supports companies requiring frequent intercity travel."
  },
  {
    "name": "Sedan Cab Sanaswadi",
    "description": "Sedan Cab Sanaswadi provides executive-class AC sedans for corporate and managerial travel. With comfortable seating, clean interiors, and professional chauffeurs, these sedans are ideal for office commute, plant visits, and business meetings. Sedan Cab Sanaswadi ensures a premium and professional travel experience."
  },
  {
    "name": "SUV Cab Sanaswadi",
    "description": "SUV Cab Sanaswadi offers spacious and comfortable SUVs suitable for long-distance travel, executive movement, and intercity visits. With high legroom, strong AC, and smooth suspension, these vehicles ensure a premium travel experience. SUV Cab Sanaswadi is ideal for managers, supervisors, and corporate guests."
  },
  {
    "name": "Worker Transportation Sanaswadi",
    "description": "Worker Transportation Sanaswadi delivers bulk employee movement solutions for factories, industrial plants, and manufacturing units. Using shuttle vans, minibuses, and tempo travellers, the service ensures timely pickup, safe travel, and smooth shift transitions. Worker Transportation Sanaswadi helps industries maintain efficient workforce operations."
  }
],
"tableData": [
  ["Sanaswadi MIDC Transport", "Industrial Employee Cab Sanaswadi"],
  ["Factory Staff Shuttle Sanaswadi", "Company Cab Provider Sanaswadi"],
  ["Sanaswadi Staff Pickup Drop", "Sanaswadi Business Cab Hire"],
  ["Monthly Corporate Cab Sanaswadi", "Best Corporate Cabs Sanaswadi"],
  ["Affordable Cab Service Sanaswadi", "Employee Commute Sanaswadi"],
  ["Corporate Fleet Sanaswadi", "Outstation Cab Sanaswadi"],
  ["Sedan Cab Sanaswadi", "SUV Cab Sanaswadi"],
  ["Worker Transportation Sanaswadi", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cabs Services in Sanaswadi",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and well-managed corporate cab services in Sanaswadi, offering safe and timely travel solutions for employees and business executives."
  },
  {
    "WhyChooseheading": "Best for Industries & Corporate Offices",
    "WhyChoosedescription": "Ideal for manufacturing units, warehouses, corporate offices, and factories located in and around the Sanaswadi industrial area."
  },
  {
    "WhyChooseheading": "Clean & Comfortable Fleet",
    "WhyChoosedescription": "Our cabs are regularly serviced, fully sanitized, and designed to deliver a smooth and comfortable travel experience for employees."
  },
  {
    "WhyChooseheading": "Affordable Corporate Packages",
    "WhyChoosedescription": "We offer cost-effective monthly and daily travel plans tailored to meet corporate transportation needs without compromising quality."
  },
  {
    "WhyChooseheading": "On-Time Pickup & Drop",
    "WhyChoosedescription": "Punctuality is our priority. We ensure timely employee pickups and drops to support organizational shift schedules and operational efficiency."
  },
  {
    "WhyChooseheading": "Trained & Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers are trained for corporate standards, ensuring safe driving and respectful behavior at all times."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance is available for cab scheduling, route changes, or urgent requirements."
  },
  {
    "WhyChooseheading": "Easy & Hassle-Free Booking",
    "WhyChoosedescription": "Book corporate cabs for Sanaswadi through our simple and quick booking process, with guaranteed service reliability."
  }
]























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide corporate cab services in Sanaswadi?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services in Sanaswadi for employee and business transportation.',
  },
  {
    question: 'How can companies in Sanaswadi book corporate cabs?',
    answer: 'Companies can book easily through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you offer employee pickup and drop services in Sanaswadi?',
    answer: 'Yes, we provide structured and punctual pickup and drop services for employees working in Sanaswadi.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Sanaswadi?',
    answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers suitable for corporate staff commute and business travel.',
  },
  {
    question: 'Are monthly or annual contracts available for Sanaswadi companies?',
    answer: 'Yes, we offer flexible monthly and yearly corporate cab contracts designed for companies located in Sanaswadi.',
  },
  {
    question: 'Are your drivers experienced with Sanaswadi and nearby routes?',
    answer: 'Absolutely. Our drivers are well-versed with Sanaswadi routes and ensure timely and safe transportation.',
  },
  {
    question: 'Do you support shift-based operations for companies in Sanaswadi?',
    answer: 'Yes, we handle all shift timings including day, night, and rotational shifts for Sanaswadi industries.',
  },
  {
    question: 'What safety and hygiene measures do you follow?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety protocols for employee transportation.',
  },
  {
    question: 'What payment options are available for corporate cab services in Sanaswadi?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Shinde',
    feedback: 'Pune Corporate Cars India Private Limited offers excellent cab services in Sanaswadi. Very professional drivers and always on time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Snehal Pawar',
    feedback: 'Their corporate cab service in Sanaswadi is dependable and well-managed. Great experience for our staff transportation.',
    rating: 5,
  },
];















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs Services in Sanaswadi",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-sanaswadi.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Sanaswadi, Pune, offering employee transport, industrial staff shuttle, office and factory pickup and drop, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Sanaswadi.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cabs-services-sanaswadi"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cabs Services in Sanaswadi | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Sanaswadi, Pune, offering employee transport, industrial staff shuttle, office and factory pickup and drop, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Sanaswadi."
  />

  <meta
    name="keywords"
    content="Sanaswadi MIDC Transport, Industrial Employee Cab Sanaswadi, Factory Staff Shuttle Sanaswadi, Company Cab Provider Sanaswadi, Sanaswadi Staff Pickup Drop, Sanaswadi Business Cab Hire, Monthly Corporate Cab Sanaswadi, Best Corporate Cabs Sanaswadi, Affordable Cab Service Sanaswadi, Employee Commute Sanaswadi, Corporate Fleet Sanaswadi, Outstation Cab Sanaswadi, Sedan Cab Sanaswadi, SUV Cab Sanaswadi, Worker Transportation Sanaswadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabsserviceinsanaswadi;